var _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCfDoneInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39.2,
    height: 39.2,
    viewBox: "0 0 39.2 39.2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6 39.2C8.79259 39.2 0 30.4074 0 19.6C0 8.79259 8.79259 0 19.6 0C30.4074 0 39.2 8.79259 39.2 19.6C39.2 30.4074 30.4074 39.2 19.6 39.2Z",
    fill: "#72B33E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.912 3.92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.7077 16.3347C30.3471 16.3347 30.0544 16.042 30.0544 15.6814C30.0557 11.6451 28.2793 7.87597 25.0525 5.06727C24.7801 4.83077 24.752 4.41787 24.9885 4.14607C25.225 3.87428 25.6379 3.84557 25.9104 4.08207C29.4266 7.14227 31.3625 11.2616 31.3612 15.6814C31.3611 16.0427 31.0684 16.3347 30.7077 16.3347Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8884 2.23501C20.8132 2.23501 20.7368 2.22192 20.6623 2.19451C19.0682 1.60582 17.3911 1.30723 15.6767 1.30662C15.3161 1.30662 15.0234 1.01392 15.0234 0.653308C15.0234 0.292009 15.3161 0 15.6767 0C17.5459 0.000689062 19.3759 0.326692 21.1144 0.968209C21.4529 1.09301 21.626 1.46931 21.5012 1.80772C21.4039 2.07163 21.1536 2.23501 20.8884 2.23501Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88 27.4367C5.7317 27.4367 5.5834 27.3871 5.46059 27.2845C1.88681 24.2922 -0.00130089 20.2782 6.72467e-07 15.6767C6.72467e-07 15.3154 0.292699 15.0234 0.653309 15.0234C1.01392 15.0234 1.30662 15.3161 1.30662 15.6767C1.30531 19.8796 3.03211 23.5468 6.29941 26.2823C6.5758 26.5136 6.61232 26.9258 6.3811 27.2022C6.25171 27.357 6.0662 27.4367 5.88 27.4367Z",
    fill: "#61A333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6788 31.3582C13.9194 31.3582 12.1906 31.0688 10.541 30.4978C10.1999 30.3795 10.0196 30.0071 10.1379 29.6668C10.2555 29.3258 10.6272 29.1441 10.9689 29.263C12.4807 29.7863 14.065 30.0516 15.6788 30.0516C16.0394 30.0516 16.3321 30.3436 16.3321 30.7049C16.3321 31.0662 16.0394 31.3582 15.6788 31.3582Z",
    fill: "#61A333"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.507 9.767)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33333 1.83333H1.83333",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08333 6.83333V18.8333",
    strokeWidth: 3.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCfDoneInfo);
export default __webpack_public_path__ + "static/media/cf-done-info.5b474f48c4eca471b3c0fae10237e423.svg";
export { ForwardRef as ReactComponent };